<template>
  <div>
    <div v-html="standardContentHTML" class="pl-supplementary-text" />
    <SubstandardBullets
      class="pl-supplementary-text--substandard"
      v-if="!(substandardAttributeVal && standardText === substandardTextAttributeVal)"
      :ordered-substandards="infoObj.substandards"
      :single-substandard-bullet="substandardAttributeVal"
      :single-substandard-text="substandardTextAttributeVal" />
  </div>
</template>

<script>
import CopyTrackWrapper from '@/components/CopyTrackWrapper'
import SubstandardBullets from '@/standards/SubstandardBullets'

export default {
  name: 'PresentLevelsStandardView',
  components: {
    CopyTrackWrapper,
    SubstandardBullets
  },
  props: {
    setCode: {
      type: String,
      required: true
    },
    longRef: {
      type: String,
      required: true
    },
    shortRef: {
      type: String,
      required: true
    },
    standardText: {
      type: String,
      required: true
    },
    infoObj: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    standardContentHTML() {
      switch (this.setCode) {
        case 'SCCCR':
          if (this.infoObj.standard_group) {
            return `<b>${this.shortRef} ${this.infoObj.standard_group}</b><br>${this.standardText}`
          }
        default:
          return `<b>${this.shortRef}</b> ${this.standardText}`
      }
    },
    substandardAttributeVal() {
      let attr = 'substandard'
      switch (this.setCode) {
        case 'CCSS':
          attr = 'standard_component'
          break
        case 'CA-ELD':
          attr = 'component'
          break
        case 'NCSCoS':
        case 'NYSNGLS':
        case 'OLS':
          attr = 'substandard_let'
          break
        case 'TEKS-2017':
          attr = 'standard_roman_numeral'
          break
      }
      return this.infoObj[attr]
    },
    substandardTextAttributeVal() {
      let attr = 'substandard_text'
      switch (this.setCode) {
        case 'CA-ELD':
        case 'CCSS':
        case 'CPLF':
        case 'TEKS':
        case 'TEKS-2017':
        case 'TPKG':
          attr = 'standard_text'
          break
        default:
          attr = 'substandard_text'
      }
      return this.infoObj[attr]
    }
  }
}
</script>

<style lang="less" scoped>
.pl-supplementary-text {
  padding-top: 0.25em;
  padding-bottom: 0.25em;
  margin: 0em;
  font-size: 0.8rem;
  line-height: 1.2rem;
}

.pl-supplementary-text--substandard {
  margin: 0em;
  font-size: 0.8rem;
  line-height: 1.2rem;
  padding-top: 0;
}
</style>
